<div class="bar-graph-table-header text">
    <div class="col-no column">
        {{ 'graph.gauge.table.header.number' | translate }}
    </div>
    <div class="col-channel column">
        {{ 'graph.bar.table.header.channel' | translate }}
    </div>
    <div class="col-bar-label column">
        {{ 'graph.bar.table.header.bar-label' | translate }}
        <div class="config-info-message">
            <mat-icon
                svgIcon="info"
                class="info-icon"
                (mouseenter)="isInfoMessageVisible = true"
                (mouseleave)="isInfoMessageVisible = false"></mat-icon>
            <ng-container *ngIf="isInfoMessageVisible">
                <div #infoMessage class="info-message-container">
                    <div>
                        {{ 'graph.bar.table.header.bar-label.info' | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="col-options column"></div>
</div>
